var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-3"},[_vm._v(" Admin moduli... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }